
export class ProductDimensionFilterOptions {
    productId: number;
    dimensionIds: Array<number>;
}
